/* eslint-disable import/no-duplicates */
import { getYear, type Locale } from "date-fns";
import en_GB from "date-fns/locale/en-GB";
import pl_PL from "date-fns/locale/pl";
/* eslint-enable import/no-duplicates */
import { range } from "lodash";

export const dateFormatForBackend = "YYYY-MM-DD 12:00:00";
export const datePickerDateFormat = "dd.MM.yyyy";
export const momentDateFormat = "YYYY-MM-DD";
export const moment24HourTimeFormat = "HH:mm";
export const languages: { [key: string]: Locale } = { en_GB, pl_PL };

export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
] as const;

const currentYear = getYear(new Date());
export const years = range(currentYear - 2, currentYear + 3, 1);
